import {DateUtils} from '../app/utils/date.utils';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateUtils} from '../app/utils/ngb-date.utils';

export class DateRange {
  public startDate: string;
  public endDate: string;

  static buildDateRangeWithBorder(fromDate: NgbDateStruct, toDate: NgbDateStruct): DateRange {
    const startDate = NgbDateUtils.parseDate(fromDate);
    const endDate = NgbDateUtils.parseDate(toDate);
    const dateRange = new DateRange();
    dateRange.startDate = DateUtils.convertDateToString(startDate, 'yyyy-MM-dd');
    dateRange.endDate = DateUtils.convertDateToString(endDate, 'yyyy-MM-dd');
    return dateRange;
  }

  static buildDateRangeWithPeriod(period: number): DateRange {
    const today = DateUtils.now();
    today.setDate(today.getDate() - 1); // TODO: HANDLE THIS MORE CLEANLY
    const startDate = DateUtils.addPerid(today, -period);
    const dateRange = new DateRange();
    dateRange.startDate = DateUtils.convertDateToString(startDate, 'yyyy-MM-dd');
    dateRange.endDate = DateUtils.convertDateToString(today, 'yyyy-MM-dd');
    return dateRange;
  }

  get formattedEndDate() {
    return new Date(this.endDate);
  }

  get formattedStartDate() {
    return new Date(this.startDate);
  }
}



// WEBPACK FOOTER //
// ./src/models/date-range.ts